<template>
  <el-dialog title="Attendance" :fullscreen="true" :visible.sync="dialogVisible">
    <el-table
      v-if="!loading"
      :data="attendance"
      :default-sort="{prop:'date', order: 'descending'}"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="Name" sortable min-width="150">
        <template slot-scope="scope">
          <span>{{ findUserAndName(scope.row.user_id) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Class" min-width="120" max-width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.user_id != null">{{ cClassName(scope.row.user_id) }}</span>
          <span v-else>N/A</span>
        </template>
      </el-table-column>
      <el-table-column min-width="110" label="Attendance">
        <template slot-scope="scope">
          <span>{{ cAttendanceType(scope.row.attendance_type) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottom clearfix">
      <el-button-group class="button">
        <el-popover
          v-if="selectedRecords.length != 0"
          v-model="delVisible"
          placement="top"
          width="160"
        >
          <p>Are you sure?</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="delVisible=false">No</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="selectedRecords.forEach((e) => {deleteAttendance(e);})"
            >Yes</el-button>
          </div>
          <el-button
            slot="reference"
            @click="delVisible=false"
            icon="el-icon-delete"
            type="danger"
            size="small"
          ></el-button>
        </el-popover>
        <el-button
          :disabled="loading"
          @click="addAttendance"
          icon="el-icon-plus"
          type="primary"
          size="small"
        />
      </el-button-group>
    </div>
    <nxs-record-detail
      ref="recordModal"
      :eventId="eventId"
      :attendanceTypes="attendanceTypes"
      @save="addRecord"
    />
  </el-dialog>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import nxsRecordDetail from "./AttendanceDetail.vue";
export default {
    name: "AttendanceManagement",
    components: {nxsRecordDetail},
    props: ["eventId"],
    computed: {...mapFields(["users"])},
    data() {
        return {
            width: "70%",
            addBatch: false,
            loading: true,
            usersLoading: true,
            searchList: [],
            attendance: null,
            attendanceTypes: null,
            selectedRecords: [],
            delVisible: false,
            tempRecord: {
                user_id: null,
                attendance_type: 4,
                event_id: this.eventId
            },
            dialogVisible: false
        };
    },
    watch: {
        tempRecord(before, after) {
            if (before && !before.o_id) {
                if (after.o_id) {
                    // Insert new record
                    this.attendance.push(after);
                }
            }
        }
    },
    mounted() {
        this.getAttendance();
        this.getAttendanceTypes();
    },
    methods: {
        handleSelectionChange(val) {
            this.$set(this, "selectedRecords", val);
        },
        open() {
            this.dialogVisible = true;
        },
        addRecord(record) {
            var i = this.attendance.findIndex((e) => e.user_id == record.user_id);
            if (i == -1) {
                this.attendance.push(record);
            } else {
                this.attendance.splice(i, 1, record);
            }
        },
        isLoading() {
            [this.attendanceTypes, this.users, this.attendance].forEach((element) => {
                if (element == null) {
                    this.loading = true;
                    return true;
                }
            });
            this.loading = false;
            return false;
        },
        cAttendanceType(id) {
            if (id == null || this.attendanceTypes == null) {
                return null;
            }
            return this.attendanceTypes.find((type) => type.o_id == id).name;
        },
        findUserAndName(id) {
            if (this.users == null) return null;
            var temp = this.users.find((user) => user.o_id == id);
            return this.getFullName(temp);
        },
        cClassName(id) {
            if (this.users == null) return null;
            var temp = this.users.find((user) => user.o_id == id);
            return temp.level.name;
        },
        getAttendanceTypes() {
            this.axios
                .get("/api/v1/attendancetypes", {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.attendanceTypes = response.data;
                    this.isLoading();
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        },
        getAttendance() {
            this.axios
                .get("/api/v1/events/" + this.eventId, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.attendance = response.data.attendance;
                    this.isLoading();
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        },
        addAttendance() {
            this.$refs.recordModal.open();
        },
        deleteAttendance(row) {
            row.del_visible = false;
            this.axios
                .delete("/api/v1/attendance/" + row.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: "Attendance record deleted successfuly",
                        type: "success"
                    });
                    var temp = this.attendance.find((objv) => objv.o_id == row.o_id);
                    var index = this.attendance.indexOf(temp);
                    this.attendance.splice(index, 1);
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: "error"
                    });
                });
        }
    }
};
</script>
